import { InternalLink } from '../Clickables/InternalLink/InternalLink';
import { ChevronRightIcon } from '../Icons/ChevronRightIcon';

import { BreadcrumbsSchema } from './BreadcrumbsSchema';
import { twMerge } from 'tailwind-merge';
import { variants } from './variants';
import { ReactNode } from 'react';

export interface IBreadcrumbItem {
  label: string;
  link?: string;
}

interface IProps {
  items: IBreadcrumbItem[];
  className?: string;
  itemClassName?: string;
  size?: 'xs' | 'sm' | 'md';
  variant?: keyof typeof variants;
  divider?: ReactNode;
}

export const Breadcrumbs = ({
  items,
  className,
  itemClassName,
  variant = 'md',
  divider = <ChevronRightIcon width={16} height={16} />,
}: IProps) => (
  <>
    <BreadcrumbsSchema items={items} />
    <ol
      className={twMerge('flex list-none flex-row flex-wrap gap-x-2 py-4', className)}
      data-testid="Breadcrumbs"
    >
      {items.map((item, index) => (
        <li
          key={`${index}-${item.label.replace(/ /g, '-')}`}
          className={twMerge(
            `${variants[variant]} mb-0 flex h-4 items-center gap-x-2 text-black`,
            itemClassName,
          )}
        >
          {item.link ? (
            <InternalLink variant="textNone" to={item.link} className="w-max hover:underline">
              {item.label}
            </InternalLink>
          ) : (
            item.label
          )}
          {index !== items.length - 1 && divider}
        </li>
      ))}
    </ol>
  </>
);
